/**
 * Hide Content UseCase
 *
 * Handles hiding a content item so the user won't see it again.
 * Calls the hideContent cloud function via mediaService.
 *
 * Pattern from Flutter: MediasRepository.hideContent
 * Source: lib/data/repository/medias_repository.dart
 */

import { MediaService } from '@/domain/services/media/mediaService';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class HideContentUseCase {
  private mediaService: MediaService;

  constructor(mediaService?: MediaService) {
    this.mediaService = mediaService || new MediaService();
  }

  async execute(media: UserMediaEntity): Promise<boolean> {
    try {
      const success = await this.mediaService.hideContent(media.id);
      if (!success) return false;

      return true;
    } catch (error) {
      appLogger.error('Error hiding content', 'HideContentUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const hideContentUseCase = new HideContentUseCase();
